webpackJsonp([10,8],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keys = __webpack_require__(34);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(47);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _promise = __webpack_require__(48);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _elementUi = __webpack_require__(105);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	__webpack_require__(89);
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(62);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(59);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _formats = __webpack_require__(200);
	
	var _formats2 = _interopRequireDefault(_formats);
	
	var _App = __webpack_require__(140);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _router = __webpack_require__(203);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _store = __webpack_require__(204);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_elementUi2.default);
	_vue2.default.use(_vueRouter2.default);
	
	if (!_vue2.default.http) {
	  _vue2.default.use(_vueResource2.default);
	}
	
	var $http = _vue2.default.http;
	var $alert = _vue2.default.prototype.$alert;
	
	$http.interceptors.push(function (request, next) {
	  next(function (response) {
	    if (!response.ok) {
	      $alert('服务器繁忙');
	      console.log(response.status, response.statusText);
	      return response;
	    }
	
	    var body = response.body;
	    if (body.responseStatus === '229') {
	      _router2.default.push('/login');
	    } else if (body.responseStatus !== '0') {
	      $alert(body.object);
	    }
	    return response;
	  });
	});
	
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;
	
	try {
	  for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(_formats2.default)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	    var key = _step.value;
	
	    _vue2.default.filter(key, _formats2.default[key]);
	  }
	} catch (err) {
	  _didIteratorError = true;
	  _iteratorError = err;
	} finally {
	  try {
	    if (!_iteratorNormalCompletion && _iterator.return) {
	      _iterator.return();
	    }
	  } finally {
	    if (_didIteratorError) {
	      throw _iteratorError;
	    }
	  }
	}
	
	_promise2.default.prototype.finally = function (callback) {
	  return this.then(function (data) {
	    callback(data);
	  }, function (data) {
	    callback(data);
	  });
	};
	
	new _vue2.default({
	  el: '#app',
	  render: function render(h) {
	    return h(_App2.default);
	  },
	  router: _router2.default,
	  store: _store2.default
	});

/***/ },

/***/ 33:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(48);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.doLogin = doLogin;
	exports.getMenu = getMenu;
	exports.getCreditList = getCreditList;
	exports.addCustomer = addCustomer;
	exports.delCustomer = delCustomer;
	exports.fetchFundsAccount = fetchFundsAccount;
	exports.fetchFundsLoan = fetchFundsLoan;
	exports.fetchFundsFlowList = fetchFundsFlowList;
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(59);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _md = __webpack_require__(63);
	
	var _md2 = _interopRequireDefault(_md);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var $http = _vue2.default.http;
	
	$http.options.root = '/zx';
	$http.options.emulateJSON = true;
	
	function mockResponse(obj) {
	  return new _promise2.default(function (resolve) {
	    setTimeout(function () {
	      resolve(obj);
	    }, 500);
	  });
	}
	
	function getRandom(min, max) {
	  return Math.round(Math.random() * (max - min) + min);
	}
	
	var menuList = [{
	  menu: {
	    menuName: '用户管理'
	  },
	  childrens: [{
	    menuName: '用户列表',
	    resourceUrl: '/userList',
	    childrens: [{
	      menuName: '查看详情',
	      resourceUrl: '/userDetail'
	    }]
	  }]
	}, {
	  menu: {
	    menuName: '权限管理'
	  },
	  childrens: [{
	    menuName: '角色管理',
	    resourceUrl: '/roleManage'
	  }, {
	    menuName: '管理员管理',
	    resourceUrl: '/adminManage'
	  }]
	}, {
	  menu: {
	    menuName: '商户管理'
	  },
	  childrens: [{
	    menuName: '商户列表',
	    resourceUrl: '/merchantManage'
	  }]
	}];
	
	var tableList = [];
	var total = 25;
	var codeInfos = ['公积金', '移动', '地税'];
	for (var i = 0; i < total; i++) {
	  var item = {
	    customer_realName: 'a' + i,
	    customer_mobile: '13000000000',
	    customer_identity: '320705198102122967',
	    customer_info: 'The info of a' + i,
	    credit_flow: i,
	    credit_time: new Date().getTime(),
	    code_info: codeInfos[getRandom(0, 2)],
	    credit_state: getRandom(0, 3)
	  };
	
	  tableList.push(item);
	}
	
	function doLogin(data) {
	  var username = 'admin';
	  var password = 'admin';
	  var captcha = '1234';
	  var mockData = {
	    body: {}
	  };
	
	  if (username === data.username && (0, _md2.default)(password) === data.password) {
	    if (captcha === data.captcha) {
	      mockData.body.responseStatus = '0';
	    } else {
	      mockData.body.responseStatus = '1';
	      mockData.body.object = '验证码错误';
	    }
	  } else {
	    mockData.body.responseStatus = '1';
	    mockData.body.object = '用户名或密码错误';
	  }
	  return mockResponse(mockData);
	}
	
	function getMenu() {
	  var mockData = {
	    body: {
	      responseStatus: '0',
	      object: menuList
	    }
	  };
	  return mockResponse(mockData);
	}
	
	function getCreditList(params) {
	  var start = params.pageSize * (params.pageNum - 1);
	  var end = start + params.pageSize;
	  var list = tableList.slice(start, end);
	  var mockData = {
	    body: {
	      responseStatus: '0',
	      object: {
	        total: total,
	        list: list
	      }
	    }
	  };
	  return mockResponse(mockData);
	}
	
	function addCustomer(params) {
	  var item = {
	    customer_realName: params.customer_realName,
	    customer_mobile: params.customer_mobile,
	    customer_identity: params.customer_identity,
	    customer_info: params.customer_info,
	    credit_flow: tableList[tableList.length - 1] + 1,
	    credit_state: 1,
	    credit_time: new Date().getTime(),
	    code_info: codeInfos[params.type_id - 1]
	  };
	  tableList.push(item);
	  total++;
	  return mockResponse({
	    body: {
	      responseStatus: '0'
	    }
	  });
	}
	
	function delCustomer(params) {
	  var mockData = void 0;
	  for (var _i = 0, len = tableList.length; _i < len; _i++) {
	    var _item = tableList[_i];
	    if (_item.credit_flow === params.credit_flow) {
	      tableList.splice(_i, 1);
	      total--;
	      mockData = {
	        body: {
	          responseStatus: '0'
	        }
	      };
	      break;
	    }
	  }
	  if (!mockData) {
	    mockData = {
	      body: {
	        responseStatus: '1',
	        object: '删除失败'
	      }
	    };
	  }
	  return mockResponse(mockData);
	}
	
	function fetchFundsAccount() {
	  return mockResponse({
	    body: {
	      responseStatus: '0',
	      object: {}
	    }
	  });
	}
	function fetchFundsLoan(params) {
	  return mockResponse({
	    body: {
	      responseStatus: '0',
	      object: {}
	    }
	  });
	}
	function fetchFundsFlowList(params) {
	  return mockResponse({
	    body: {
	      responseStatus: '0',
	      object: {
	        total: 0,
	        list: []
	      }
	    }
	  });
	}

/***/ },

/***/ 89:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 92:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 140:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(92)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(206),
	  /* template */
	  __webpack_require__(157),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 157:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ },

/***/ 200:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(34);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(47);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatTime(time) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm:ss.S';
	
	  var timeObj = new Date(time);
	  var o = {
	    'M+': timeObj.getMonth() + 1,
	    'd+': timeObj.getDate(),
	    'h+': timeObj.getHours(),
	    'm+': timeObj.getMinutes(),
	    's+': timeObj.getSeconds(),
	    S: timeObj.getMilliseconds()
	  };
	  if (/(y+)/.test(format)) {
	    var year = String(timeObj.getFullYear());
	    var matched = RegExp.$1;
	    format = format.replace(matched, year.substr(4 - matched.length));
	  }
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(o)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var key = _step.value;
	
	      if (new RegExp('(' + key + ')').test(format)) {
	        var _matched = RegExp.$1;
	        format = format.replace(_matched, _matched.length === 1 ? o[key] : ('00' + o[key]).substr(String(o[key]).length));
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return format;
	}
	
	exports.default = {
	  formatTime: formatTime
	};

/***/ },

/***/ 203:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueRouter = __webpack_require__(62);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Login = function Login(resolve) {
	  return __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(142)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Home = function Home(resolve) {
	  return __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(144)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Welcomme = function Welcomme(resolve) {
	  return __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(148)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var UserList = function UserList(resolve) {
	  return __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(153)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var UserDetail = function UserDetail(resolve) {
	  return __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(152)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var RoleManage = function RoleManage(resolve) {
	  return __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(150)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var AdminManage = function AdminManage(resolve) {
	  return __webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(149)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var MerchantManage = function MerchantManage(resolve) {
	  return __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(151)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var routes = [{
	  path: '/login',
	  component: Login,
	  meta: {
	    label: '登录'
	  }
	}, {
	  path: '/',
	  component: Home,
	  meta: {
	    label: '首页'
	  },
	  children: [{
	    path: '',
	    component: Welcomme,
	    meta: {
	      label: '首页'
	    }
	  }, {
	    path: 'userList',
	    component: UserList,
	    meta: {
	      label: '用户列表',
	      ancestors: ['用户管理']
	    }
	  }, {
	    path: 'userDetail',
	    component: UserDetail,
	    meta: {
	      label: '查看详情',
	      ancestors: ['用户管理', '用户列表']
	    }
	  }, {
	    path: 'roleManage',
	    component: RoleManage,
	    meta: {
	      label: '角色管理',
	      ancestors: ['权限管理']
	    }
	  }, {
	    path: 'adminManage',
	    component: AdminManage,
	    meta: {
	      label: '管理员管理',
	      ancestors: ['权限管理']
	    }
	  }, {
	    path: 'merchantManage',
	    component: MerchantManage,
	    meta: {
	      label: '商户列表',
	      ancestors: ['商户管理']
	    }
	  }]
	}];
	
	exports.default = new _vueRouter2.default({
	  routes: routes
	});

/***/ },

/***/ 204:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(61);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _menu = __webpack_require__(205);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	  modules: {
	    menu: _menu2.default
	  }
	});

/***/ },

/***/ 205:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(33);
	
	var state = {
	  menuList: []
	};
	
	var mutations = {
	  setMenuList: function setMenuList(state, payload) {
	    state.menuList = payload.menuList;
	  },
	  clearMenuList: function clearMenuList(state) {
	    state.menuList = [];
	  }
	};
	
	var actions = {
	  fetchMenu: function fetchMenu(_ref) {
	    var commit = _ref.commit;
	
	    return (0, _api.getMenu)().then(function (res) {
	      var body = res.body;
	      if (body.responseStatus === '0') {
	        commit('setMenuList', { menuList: body.object });
	      }
	    });
	  }
	};
	
	var getters = {
	  menuList: function menuList(state) {
	    return state.menuList;
	  }
	};
	
	exports.default = {
	  state: state,
	  mutations: mutations,
	  actions: actions,
	  getters: getters
	};

/***/ },

/***/ 206:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'app'
	};

/***/ },

/***/ 215:
/***/ function(module, exports) {

	/* (ignored) */

/***/ }

});


// WEBPACK FOOTER //
// static/js/app.86fcfa5f986eb19c92cb.js